// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriversPauseHistoryUI_denied__zGciX {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  color:#F13C02;
}

.DriversPauseHistoryUI_approve__PF8sD{
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  color:#0EC315;
}

.DriversPauseHistoryUI_pending__PC3iY{
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  color: var(--darkGray)
}

.DriversPauseHistoryUI_loader__qfY0Q{
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.DriversPauseHistoryUI_actions__Ux0mV {
  display: flex;
  gap:25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/drivers-pause-history/styles/DriversPauseHistoryUI.module.css"],"names":[],"mappings":"AAAA;EACI,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACjB;;AAEA;EACI,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACjB;;AAEA;EACI,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;AACJ;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACX;;AAEA;EACI,aAAa;EACb,QAAQ;AACZ","sourcesContent":[".denied {\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14.06px;\n    color:#F13C02;\n}\n\n.approve{\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14.06px;\n    color:#0EC315;\n}\n\n.pending{\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14.06px;\n    color: var(--darkGray)\n}\n\n.loader{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n}\n\n.actions {\n    display: flex;\n    gap:25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"denied": `DriversPauseHistoryUI_denied__zGciX`,
	"approve": `DriversPauseHistoryUI_approve__PF8sD`,
	"pending": `DriversPauseHistoryUI_pending__PC3iY`,
	"loader": `DriversPauseHistoryUI_loader__qfY0Q`,
	"actions": `DriversPauseHistoryUI_actions__Ux0mV`
};
export default ___CSS_LOADER_EXPORT___;
